<template>
  <h1 class="title">
    <slot />
  </h1>
</template>

<script>
export default {};
</script>

<style scoped>
.title {
  width: 100%;
  color: #ffffff;
  font-size: 2em;
  text-align: center;
}
</style>
